import { render } from "./CurrentEventComponent.vue?vue&type=template&id=02f2936c"
import script from "./CurrentEventComponent.js?vue&type=script&lang=js"
export * from "./CurrentEventComponent.js?vue&type=script&lang=js"

import "./CurrentEventComponent.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__